<template>
  <div class="yxtbiz-teacher-experience">
    <div class="experience-container">
      <div class="experience-container__timerange">
        <label>{{ $t('pc_biz_lbl_timerange').d('时间范围') }}</label>
        <div class="context">
          <yxt-radio-group v-model="timeType">
            <yxt-radio v-model="timeType" :label="1">{{ $t('pc_biz_tit_oneyear').d('近一年') }}</yxt-radio>
            <yxt-radio v-model="timeType" :label="2">{{ $t('pc_biz_tit_lastyear').d('去年全年') }}</yxt-radio>
            <yxt-radio v-model="timeType" :label="3">{{ $t('pc_biz_rule_custom').d('自定义') }}</yxt-radio>
          </yxt-radio-group>
          <yxt-date-picker
            v-if="timeType === 3"
            v-model="timeRange"
            @change='changeHandler'
            style='width: 408px;'
            :isFixed="true"
            size="small"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm"
            type="datetimerange"
            range-separator="~"
            class="date-picker">
          </yxt-date-picker>
        </div>
      </div>
      <div class="experience-container__paramvalue mt16">
        <label>{{ $t('pc_biz_label_paramvalue').d('参数指标') }}</label>
        <div class="context">
          <yxt-checkbox-group
            v-model="checkedParams"
            @change="handleCheckedParamsChange"
          >
            <yxt-checkbox
              v-for="param in params"
              :name="param.name"
              :label="param.label"
              :key="param.label"
            >
              {{ param.name }}
              <yxt-input-number
                size="small"
                v-model="param.value"
                :min="0"
                :disabled="!checkedParams.includes(param.label)"
                width="104"
                class="pl8"
              ></yxt-input-number>
              <span v-if="param.suffix" class="pl8">h</span>
            </yxt-checkbox>
          </yxt-checkbox-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'YxtbizTeacherExperience',
  data() {
    return {
      timeType: 1,
      timeRange: '',
      checkedParams: [],
      params: [
        {
          name: this.$t('pc_biz_lbl_teacher_coursevalue').d('讲师课程价值'),
          label: 'aaa',
          value: 0
        },
        {
          name: this.$t('pc_biz_lbl_teacher_coursecount').d('主讲课件数'),
          label: 'bbb',
          value: 0
        },
        {
          name: this.$t('pc_biz_lbl_course_timelength').d('授课时长'),
          label: 'ccc',
          value: 0,
          suffix: true
        },
        {
          name: this.$t('pc_biz_lbl_course_joincount').d('授课参与人数'),
          label: 'ddd',
          value: 0
        },
        {
          name: this.$t('pc_biz_te_lbl_face_satisfaction').d('面授满意度'),
          label: 'eee',
          value: 0
        },
        {
          name: this.$t('pc_biz_te_lbl_live_courseLength').d('直播时长'),
          label: 'fff',
          value: 0,
          suffix: true
        },
        {
          name: this.$t('pc_biz_lbl_tlive_joincount').d('直播参与人数'),
          label: 'ggg',
          value: 0
        },
        {
          name: this.$t('pc_biz_lbl_course_coursecount').d('授课课程数'),
          label: 'hhh',
          value: 0
        },
        {
          name: this.$t('pc_biz_te_lbl_face_courseLength').d('面授时长'),
          label: 'iii',
          value: 0,
          suffix: true
        },
        {
          name: this.$t('pc_biz_lbl_face_joincount').d('面授参与人数'),
          label: 'jjj',
          value: 0
        }
      ]
    };
  },
  computed: {
    checkedValues() {
      const arr = [];
      this.params.forEach(param => {
        if (this.checkedParams.includes(param.label)) {
          arr.push({
            label: param.label,
            value: param.value
          });
        }
      });
      return arr;
    }
  },
  created() {
    // 默认全选
    this.params.forEach(param => {
      this.checkedParams.push(param.label);
    });
  },
  methods: {
    changeHandler() {
      // console.log(this.timeRange);
    },
    handleCheckedParamsChange() {
      // console.log(this.checkedParams);
      // console.log(this.checkedValues);
    }
  }
};
</script>
